<template>
  <div v-if="registerObj" class="modal__body" ref="modal">
    <transition name="register">
      <div v-if="!success">
        <BaseCaption :text="registerObj.title" tag="h3" />
        <form @submit.prevent="register">
          <BaseLabel forInput="fullName" :text="registerObj.nameLabel">
            <BaseField v-model="form.full_name" name="fullName"  :class="[{'modal__field_error': errors.full_name}]"/>
            <BaseErrorMessage v-if="errors.full_name">
              {{ errors.full_name[0] }}
            </BaseErrorMessage>
          </BaseLabel>
          <BaseLabel forInput="registerEmail" :text="registerObj.emailLabel">
            <BaseField v-model="form.email" name="registerEmail" type="email" :class="[{'modal__field_error': errors.email}]"/>
            <BaseErrorMessage v-if="errors.email">
              {{ errors.email[0] }}
            </BaseErrorMessage>
          </BaseLabel>
          <BaseLabel forInput="tel" :text="registerObj.phoneLabel">
            <BaseField v-model="form.phone" name="tel" maskEnabled="true" :class="[{'modal__field_error': errors.phone}]" />
            <BaseErrorMessage v-if="errors.phone">
              {{ errors.phone[0] }}
            </BaseErrorMessage>
          </BaseLabel>
          <BaseCheckbox
            forInput="agree"
            :text="registerObj.dataProcessingAgreementLabel"
            v-model="userAgree"
          >
            <input v-model="userAgree" type="checkbox" id="agree" />
          </BaseCheckbox>
          <!-- <GoogleRecaptcha @verify="onCapcha" /> -->
          <button
            :class="[
              'btn  btn--default  btn--mb-30',
              { 'btn--disabled': !userAgree }
            ]"
            type="submit"
          >
            {{ registerObj.buttonLabel }}
          </button>
          <BaseText text="Вже зареєстровані?" />
          <a class="link" href="#" @click.prevent="$emit('login', true)">
            Увійти</a
          >
        </form>
      </div>
      <div v-if="success">
        <BaseCaption :text="registerObj.thankYouTitle" tag="h3" />
        <BaseText :text="registerObj.thankYouDescription" />
      </div>
    </transition>
  </div>
</template>

<script>
// import GoogleRecaptcha from '~/components/GoogleRecaptcha'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      success: false,
      // isCaptchaVerified: false,
      form: {
        full_name: '',
        email: '',
        phone: ''
      },
      userAgree: false,
      errors: {}
    }
  },
  computed: {
    ...mapGetters({
      registerObj: 'common/registerModal'
    }),
    registrationEnabled() {
      return this.messages.global.registrationEnabled
    }
  },
  // components: {
  //   GoogleRecaptcha
  // },
  methods: {
    register() {
      if (!this.userAgree) return

      this.$store
        .dispatch('auth/registerUser', this.form)
        .then(({data}) => {
          this.success = true

          this.$router.push({
            path: `/confirm-registration-page`,
            query: { 
              full_name: this.form.full_name,
              phone: this.form.phone,
              email: this.form.email,
              user_id: data.user_id
            },
          })
          this.$store.commit('common/TOGGLE_MODAL', false)
        })
        .catch(({ response }) => {
          this.errors = response.data.message ? response.data.message : ''
        })
    }
  },
  async beforeCreate() {
    const { data } = await this.$axios.get('/registration-page')

    this.$store.commit('common/SET_REGISTER', { ...data })
  }
}
</script>

<style lang="scss">
.register-enter-active,
.register-leave-active {
  transition: opacity 0.5s;
}
.register-enter,
.register-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// components/modals/AppRegisterModal.vue